/**
 * Search autocomplete item template.
 * @module components/SearchAutocomplete/ItemTemplate
 */

function ItemTemplate({ item, icon }) {
  return (
    <span className="row align-items-center">
      <span className="col-auto">
        <i className={`fas ${icon}`} aria-hidden="true"></i>
      </span>
      <span className="col">{item}</span>
    </span>
  );
}

function RecentSearchItemTemplate({ item, onRemove }) {
  return (
    <span className="row align-items-center">
      <span className="col-auto">
        <i className={'fas fa-clock-rotate-left'} aria-hidden="true"></i>
      </span>
      <span className="col">{item.label}</span>
      <button
        type="button"
        className="br-button circle small"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onRemove(item.id);
        }}
      >
        <i className={'fas fa-xmark'} aria-hidden="true"></i>
      </button>
    </span>
  );
}

export { ItemTemplate, RecentSearchItemTemplate };
